module.exports = __webpack_public_path__ + "static/media/filter.1db187c7.svg";